import "~/styles/video-widget.scss";
import { Emitter } from "../core/Emitter";
import axios from "axios";

/*
 * TODO: найти ответ на вопрос "КАКАЯ ТУТ ИДЕЯ?" и переписать на более читабельный и масштабируемый
 * */
export class videoWidgetsGenerator {
  constructor(options, domain, device, startTime, emitterFormWidget) {
    this.options = options;
    this.domain = domain;
    this.device = device;
    this.emitterWidgets = new Emitter();
    this.emitterFormWidget = emitterFormWidget;
    this.startTime = startTime;
    this.videoWidgetUniqIds = [];
    this.formDisplayType = null;
    window.players = {};
  }
  async init() {
    this.addGooglePreloadLinks();
    this.addGoogleFontsLinks();
  }
  async _renderWidgets(videoWidgetUniqIds) {
    this.domain = this.domain.split(":")[0];
    this.videoWidgetUniqIds = videoWidgetUniqIds;
    await Object.keys(window.players).forEach(key => {
      const player = window.players[key];
      !player.isDisposed() && player.dispose();
    });
    try {
      const response = await axios.get(`https://${this.options.server_host}${this.options.init_contollerWidget}`, {
        params: new URLSearchParams({
          domain: this.domain,
          action: "init",
          widgets: this.videoWidgetUniqIds,
          is_mobile: +(this.device === "mobile")
        })
      });
      await this.generateFreeVideoWidget(response.data);
    } catch (e) {
      console.error(e);
    }
  }
  checkDeviceIsIOS() {
    return navigator.userAgent.match(/iPhone/gi);
  }
  checkIsIPadOS() {
    return /iPad|Macintosh/.test(navigator.userAgent);
  }
  checkIsMacOs() {
    return /(macintosh|macintel|macppc|mac68k|macos)/i.test(navigator.userAgent.toLowerCase());
  }
  checkIsModernSafariBrowser() {
    //проверка на версию сафари
    const safariVersion = navigator.userAgent.match(/Version\/\d\d/);
    if (safariVersion) {
      return safariVersion[0]?.split("/")[1] >= 15;
    } else {
      return false;
    }
  }
  addGooglePreloadLinks() {
    let preconnectFirstLink = document.head.querySelector(`link#google_preconnect_first`);
    let preconnectSecondLink = document.head.querySelector(`link#google_preconnect_second`);
    if (!preconnectFirstLink) {
      document.head.insertAdjacentHTML("beforeend", `<link id="google_preconnect_first" rel="preconnect" href="https://fonts.googleapis.com">`);
    }
    if (!preconnectSecondLink) {
      document.head.insertAdjacentHTML("beforeend", `<link id="google_preconnect_second" rel="preconnect" href="https://fonts.gstatic.com" crossorigin>`);
    }
  }
  addGoogleFontsLinks() {
    document.head.insertAdjacentHTML("beforeend", `<link id="Exo2" href="https://fonts.googleapis.com/css2?family=Exo+2:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet">`);
  }

  /**
   * @param {VideoWidgetItem[]} data
   * */
  async generateFreeVideoWidget(data) {
    let options = {
      // настройки скрипта
      ...this.options,
      emitterWidgets: this.emitterWidgets,
      emitterFormWidget: this.emitterFormWidget,
      domain: this.domain,
      device: this.device,
      isIOSDevice: this.checkDeviceIsIOS(),
      isMacOSDevice: this.checkIsMacOs(),
      isIPadOsDevice: this.checkIsIPadOS(),
      isModernSafariBrowser: this.checkIsModernSafariBrowser()
    };
    //отстраиваем только виджеты, которые прошли обработку
    const widgetsData = data.filter(widget => widget.status !== "in processing");
    const statisticsWidgetsData = {};
    const module = await import(/* webpackChunkName: "VideoWidgetModule" */"./videoWidget");
    const widgets = [];
    const widgetsAfterRender = [];
    const widgetsNotInBody = widgetsData.filter(elem => elem.type_display === 2 || elem.type_display === 3);
    //заполняем объект для сбора статистики по виджетам
    widgetsData.forEach(elem => statisticsWidgetsData[elem.id] = {
      ...elem
    });
    //если есть виджеты, которые не должны находиться в теле страницы, создаем для них обертку для последующего расположения их в ряд друг за другом
    if (widgetsNotInBody?.length > 0) {
      if (!this.$widgetsWrapper) {
        this.$widgetsWrapper = document.createElement("div");
        this.$widgetsWrapper.classList.add("qform__freewidgets-wrapper");
        document.body.append(this.$widgetsWrapper);
      }
      //если виджеты инициализируются формой или квизом в модальном окне
      if (this.formDisplayType === 1) {
        this.$widgetsWrapper.classList.add("qform__high-zindex");
      }
    }
    widgetsData.forEach(widget => {
      if (widget.active) {
        const nodes = Array.from(document.querySelectorAll(`[data-widget=${widget.id}]`));
        if (nodes.length === 0) {
          return console.warn(`QFormOrganizer->generateFreeVideoWidget: "Не найден родительский элемент виджета ${widget.id}!"`);
        } else {
          nodes.forEach(node => {
            if (widget.type_display === 2 || widget.type_display === 3) {
              node.classList.add("qform__freewidget");
              this.$widgetsWrapper?.append(node);
            }
          });
        }
        widgets.push(...nodes.map((node, idx) => {
          node.setAttribute("data-index-widget", idx);
          const videoWidget = new module.VideoWidget(node, {
            ...widget,
            widgetIndex: idx,
            options
          });
          //если виджет вертикальный или круглый, то подписываемся на событие отключение виджета при открытии другого круглого или вертикального
          if (widget.type_display === 2 || widget.type_display === 3) {
            this.emitterWidgets.subscribe("clearFreeWidgets", () => videoWidget.closeWidget());
          }
          widgetsAfterRender.push(videoWidget);
          return videoWidget.render();
        }));
      }
    });
    const widgetsUniqIdsReversed = this.videoWidgetUniqIds.reverse();
    const widgetsWithSessionLifecycle = widgetsAfterRender.filter(widget => widget.sessionLifecycle);
    const widgetsToClose = [];
    let isAllSessionWidgetsClosed;
    let foundLastWidgetInDom = false;
    if (widgetsWithSessionLifecycle) {
      isAllSessionWidgetsClosed = widgetsWithSessionLifecycle.every(widget => sessionStorage.getItem(widget.id));
    }
    widgetsUniqIdsReversed.forEach(id => {
      const widgetWithId = widgetsAfterRender.find(widget => widget.id === id);

      //очищаем localStorage от количества отстроек при наличии предыдущих записей об этом виджете
      try {
        const initsData = JSON.parse(localStorage.getItem("qform_widgets_init_counter"));
        if (initsData[widgetWithId.id].type !== widgetWithId.settings.type_display) {
          delete initsData[widgetWithId.id];
          localStorage.setItem("qform_widgets_init_counter", JSON.stringify(initsData));
        }
      } catch (e) {
        console.warn("There is no data in localStorage with this widget ID");
      }

      //если виджет вертикальный или круглый, и загружается сразу со страницей
      if (widgetWithId?.stylePreview !== 1 && widgetWithId?.settings.load_by === 1) {
        if (widgetsWithSessionLifecycle.length && !isAllSessionWidgetsClosed) {
          //если виджет не закрыт пользователем
          if (widgetWithId.sessionLifecycle && !foundLastWidgetInDom) {
            if (!sessionStorage.getItem(id)) {
              foundLastWidgetInDom = true;
            } else {
              addWidgetToClose(widgetWithId);
            }
          } else {
            addWidgetToClose(widgetWithId);
          }
        } else {
          if (!widgetWithId.sessionLifecycle && !foundLastWidgetInDom) {
            foundLastWidgetInDom = true;
          } else {
            addWidgetToClose(widgetWithId);
          }
        }

        //закрытие виджетов при превышении количества инициализаций
        if (widgetWithId.settings.show_one === 2 && !widgetsToClose.includes[widgetWithId]) {
          try {
            const inits = JSON.parse(localStorage.getItem("qform_widgets_init_counter"))[widgetWithId.id].count;
            if (inits && inits >= 3) {
              addWidgetToClose(widgetWithId);
            }
          } catch (e) {
            console.warn("This widget was started the first time");
          }
        }
      }
    });
    await Promise.all(widgets);
    widgetsToClose.forEach(widget => {
      widget.closeWidget({
        forcedClose: true
      });
    });
    this.freeWidgets = widgetsAfterRender;

    //функция добавления виджета в стек тех, которые нужно принудительно закрыть
    function addWidgetToClose(widgetWithId) {
      widgetWithId.avoidStatistics = true;
      widgetWithId.avoidPlay = true;
      widgetsToClose.push(widgetWithId);
    }
  }
}